import React from 'react';
import { useSelector } from 'react-redux';
import Truncate from 'react-truncate';
import urlParse from 'url';

import {
  Button,
  Container,
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  DEFAULT_LANGUAGE,
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../../config/constants';

import './style.scss';

const HighlightedArticleOrStory = ({ id, entity }) => {
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const highlight = entity.toJS();
  const linkText = highlight.field_linktext[0].value;
  const secondaryLink = highlight.field_link_secondary[0];
  const intro = highlight.field_body[0]?.processed;
  const caption = highlight.field_caption[0]?.value;

  const articleOrStory = highlight.field_story_or_article[0]?.entity;

  // It is possible to reference an article or story which is unpublished.
  // But, we want to prevent crashes.
  if (!articleOrStory) {
    return;
  }

  const link = urlParse.parse(
    articleOrStory.paths[currentLanguage]
      ? articleOrStory.paths[currentLanguage]
      : articleOrStory.paths[DEFAULT_LANGUAGE],
  );
  const isArticle = articleOrStory.type[0].target_id === 'article';
  const styles = articleOrStory.field_media_item[0]?.styles;
  const source = {
    [SCREEN_MOBILE]: styles?.['4_3_mobile'],
    [SCREEN_NORMAL]: styles?.['4_3'],
  };

  return (
    <div id={id} className="Paragraph HighlightedArticleOrStory">
      <Container>
        <div className="row">
          <div className="col-12 col-md-5 col-lg-6">
            <div className="HighlightedArticleOrStory__wrapper">
              {/* Image */ }
              {styles && (
                <Image
                  className="HighlightedArticleOrStory__image"
                  src={source}
                />
              )}
              <div className="HighlightedArticleOrStory__icon">
                <i className={`icon icon-${isArticle ? 'announce' : 'person-contact'} icon-variant-1`} />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7 col-lg-5 offset-lg-1">
            <div className="HighlightedArticleOrStory__wrapper">
              <div className="HighlightedArticleOrStory__content">
                {/* Caption */}
                {caption && (
                  <div className="HighlightedArticleOrStory__content__label">
                    <span>{caption}</span>
                  </div>
                )}
                {/* Title */}
                <h2 className="HighlightedArticleOrStory__content__title">
                  {articleOrStory.title[0].value}
                </h2>
                {/* Body */}
                <div className="HighlightedArticleOrStory__content__summary">
                  <Truncate lines={6} ellipsis="...">
                    <WysiwygField
                      html={intro ?? articleOrStory.body[0]?.summary}
                    />
                  </Truncate>
                </div>

                {/* Actions */}
                <div className="HighlightedArticleOrStory__content__buttons">
                  <Button className="linkPrimary" href={link.pathname}>
                    {linkText}
                  </Button>
                  {secondaryLink && (
                    <Button
                      className="linkSecondary"
                      href={secondaryLink.alias || secondaryLink.uri}
                      target={secondaryLink.options?.attributes?.target ?? '_self'}
                      primary={false}
                    >
                      {secondaryLink.title}
                      <i className="icon icon-arrow-right icon-variant-2" />
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HighlightedArticleOrStory;
